import { fetchAll } from '../../services/helpers';
import _ from 'lodash';
import { useQuery } from '@tanstack/react-query';

export const useSequences = () => useQuery({
  queryKey: ['sequencesTable'],
  queryFn: () => fetchAll('sequences/table'),
  onSuccess: (data) => {
    return data;
  },
});
